//src/components/StickyFooter.tsx (checked 11/16/25)

import {
  FaYoutube,
  FaInstagram,
  FaFacebook,
  FaSnapchatGhost,
  //FaLinkedin,
  //FaPinterest
} from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
import XIcon from './XIcon';
import '../index.css';

const StickyFooter = () => {
  return (
    <footer className="sticky-footer">
      <div className="sticky-footer__socials">
        {/* YouTube */}
        <a
          href="https://youtube.com/@crushhh"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          aria-label="YouTube"
        >
          <FaYoutube size={28} />
        </a>

        {/* Instagram */}
        <a
          href="https://www.instagram.com/crushhhfun"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          aria-label="Instagram"
        >
          <FaInstagram size={28} />
        </a>

        {/* Facebook */}
        <a
          href="https://www.facebook.com/crushhhfun"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          aria-label="Facebook"
        >
          <FaFacebook size={28} />
        </a>

        {/* X */}
        <a
          href="https://x.com/Crushhhfun"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          aria-label="X"
        >
          <XIcon size={28} />
        </a>

        {/* Snapchat */}
        <a
          href="https://snapchat.com/add/crushhhfun" //still needs Crushhh link
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          aria-label="Snapchat"
        >
          <FaSnapchatGhost size={28} />
        </a>

        {/* LinkedIn 
        <a
          href="https://linkedin.com" //still needs Crushhh link
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          aria-label="LinkedIn"
        >
          <FaLinkedin size={28} />
        </a>

        {/* Pinterest 
        <a
          href="https://pinterest.com" //still needs Crushhh link
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          aria-label="Pinterest"
        >
          <FaPinterest size={28} />
        </a> */}

        {/* TikTok */}
        <a
          href="https://tiktok.com/@crushhhfun" //still needs Crushhh link
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
          aria-label="TikTok"
        >
          <SiTiktok size={28} />
        </a>
      </div>

      {/* Legal Links */}
      <div
        className="sticky-footer__legal"
        style={{
          fontFamily: "'Fredoka', sans-serif",
          fontWeight: 500,
          fontSize: 13,
          color: "#FFFFFF",
        }}
      >
        <a
          href="/#/terms"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#FFFFFF" }}
        >
          Terms & Conditions
        </a>
        <a
          href="/#/privacy"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#FFFFFF" }}
        >
          Privacy Policy
        </a>
        <a
          href="/#/cookies"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#FFFFFF" }}
        >
          Cookie Policy
        </a>
        <a
          href="/#/contact"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#FFFFFF" }}
        >
          Contact Us
        </a>
      </div>
    </footer>
  );
};

export default StickyFooter;
